var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.placeholderStyles)?_c('div',{style:(_vm.placeholderStyles)}):_vm._e(),_c('div',{ref:"child",staticClass:"ten-affix",class:_vm.className,style:(_vm.styles)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }